<div class="tabs">
  <div
    class="tab"
    *ngFor="let tab of tabs; let i = index"
    (click)="selectTab(tab, i)"
    [class.active]="tab.active"
  >
    <h6>{{ tab.title }}</h6>
  </div>
</div>

<ng-content> </ng-content>
